export function scroll_to_syllable(
  scrollParent: HTMLElement,
  svg: SVGSVGElement,
  syllableIndex: number,
) {
  const syllable = svg.querySelector(`.syllable-${syllableIndex}`);
  if (syllable) {
    const rect = syllable.getBoundingClientRect();
    const svgRect = svg.getBoundingClientRect();
    const scrollParentRect = scrollParent.getBoundingClientRect();
    // const scrollParentScrollTop = scrollParent.scrollTop;
    const svgTop = svgRect.top;
    const syllableTop = rect.top;
    const syllableHeight = rect.height;
    const scrollParentHeight = scrollParentRect.height;

    const newScrollTop = syllableTop - svgTop - scrollParentHeight / 2 + syllableHeight / 2;
    scrollParent.scrollTo({
      top: newScrollTop,
      // behavior: 'smooth',
    });
  }
}
